import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { SectionTitle, PaddedContainer } from '../common/styles';
import Profile, { profileWidth } from './profile';

const members = [
  { name: 'Tom McKay', title: 'Co-Founder', titleSecondary: 'Managing Director' },
  { name: 'James Marlay', title: 'Co-Founder', titleSecondary: 'Executive Director' },
  { name: 'Alex Cowie', title: 'Editorial Director' },
  { name: 'Anthony Deane', title: 'Product Director' },
  { name: 'Adrian Cachia', title: 'Partnerships Director' },
  { name: 'Amit Friedmann', title: 'Chief Technology Officer' },
  { name: 'Eddie Orchard', title: 'Partnerships Manager' },
  { name: 'Patrick Poke', title: 'Editor' },
  { name: 'Tais Santiago', title: 'Partnerships Manager' },
  { name: 'Maria Lucia Perez', title: 'Events Manager' },
  { name: 'Huy Hoang', title: 'Software Engineer' },
  { name: 'Zhengang Li', title: 'Software Engineer' },
];

const Container = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;
  border-top-left-radius: 200px;
  border-bottom-right-radius: 200px;
  background-color: ${props => props.theme.secondaryColorLight};
`;

const contentPct = 76.1;

const Content = styled.div`
  max-width: 1096px;
  width: ${contentPct}vw;
  display: flex;
  flex-direction: column;
  padding: 140px 0;
`;

const MobileContainer = styled(PaddedContainer)`
  padding-top: 95px;
  display: flex;
  flex-direction: column;
`;

const Title = styled(SectionTitle)`
  margin: 0;
`;

const Desc = styled.p`
  margin-top: 20px;
  margin-bottom: ${props => (props.theme.isMobile ? 38 : 50)}px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 20px;
  line-height: 25px;
  ${props => (!props.theme.isMobile && `
    width: 468px;
  `)};
`;

export default function Team() {
  // two tile layout, with 20px padding on both sides, and 20px spacing in between
  const minWidthMobile = 2 * profileWidth + 2 * 20 + 20;
  const isTwoTilesPerRow = useMediaQuery({ query: `(min-width: ${minWidthMobile}px)` });
  const { team, isMobile } = React.useContext(ThemeContext);
  const data = members.map((d, i) => ({ ...d, photo: team[i] }));

  // The three tiles per row extra element is based on 14 team members to combat
  // the 'space-between' layout for the last row. Adjust that if team member
  // number is changed.
  const ProfileContainer = styled.div`
    display: flex;
    ${(isMobile && !isTwoTilesPerRow) ? `
      flex-direction: column;
      align-items: center;
    ` : `
      flex-wrap: wrap;
      justify-content: space-between;
    `};
  `;

  function renderContent() {
    return (
      <React.Fragment>
        <Title>The Livewire Team</Title>
        <Desc>
          Our team is committed to delivering our purpose: to help investors make
          confident investment decisions
        </Desc>
        <ProfileContainer>
          {data.map(profile => <Profile {...profile} key={profile.name} />)}
        </ProfileContainer>
      </React.Fragment>
    );
  }

  return isMobile
    ? (
      <MobileContainer id="team">
        {renderContent()}
      </MobileContainer>
    )
    : (
      <Container id="team">
        <Content>
          {renderContent()}
        </Content>
      </Container>
    );
}
